const Copyright = () => {
	return (
		<div className="insar-ControlPanel-copyright">
			© Gisat {`${new Date().getFullYear()}`}. European Space Agency, EO4SD
			Disaster Risk Reduction cluster ({`${new Date().getFullYear()}`})
		</div>
	);
};

export default Copyright;
